import { render, staticRenderFns } from "./Table.vue?vue&type=template&id=00e753fa&scoped=true&"
import script from "./Table.vue?vue&type=script&lang=js&"
export * from "./Table.vue?vue&type=script&lang=js&"
import style0 from "./Table.vue?vue&type=style&index=0&id=00e753fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00e753fa",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ProductLink: require('/usr/src/motec/components/product/Link.vue').default})
